var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.063,
    height: 15.995,
    viewBox: "0 0 13.063 15.995",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "delete",
    transform: "translate(0.158 0.15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19512",
    "data-name": "Path 19512",
    d: "M1.041,4.671v9.056a2.028,2.028,0,0,0,.539,1.4,1.81,1.81,0,0,0,1.313.568H9.848a1.81,1.81,0,0,0,1.313-.568,2.028,2.028,0,0,0,.539-1.4V4.671a1.4,1.4,0,0,0-.36-2.761H9.458V1.45A1.444,1.444,0,0,0,8,0H4.738A1.444,1.444,0,0,0,3.283,1.45V1.91H1.4a1.4,1.4,0,0,0-.36,2.761ZM9.848,14.959H2.893a1.164,1.164,0,0,1-1.117-1.231V4.7h9.189v9.024a1.164,1.164,0,0,1-1.117,1.231ZM4.018,1.45a.708.708,0,0,1,.72-.717H8a.708.708,0,0,1,.72.717V1.91h-4.7ZM1.4,2.645H11.34a.662.662,0,0,1,0,1.323H1.4a.662.662,0,1,1,0-1.323Zm0,0",
    transform: "translate(0.003 0.002)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.3
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteDark);
export default __webpack_public_path__ + "static/media/deleteDark.1e4bf28f5fdcb85ab86a080477daf747.svg";
export { ForwardRef as ReactComponent };